import { Stack, SxProps, Theme } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { ReactNode } from "react";

interface MuiLoadingButtonProps {
    buttonClasses?: string;
    type?: 'button' | 'submit' | 'reset';
    title?: string;
    color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    disabled?: boolean;
    isLoading?: boolean;
    variant?: 'text' | 'outlined' | 'contained';
    onClick?: () => void;
    startIcon?: ReactNode;
    endIcon?: ReactNode;

    sx?: SxProps<Theme>
}

export const MuiLoadingButton = (props: MuiLoadingButtonProps) => {
    const {
        buttonClasses = "",
        type = "button",
        color = 'primary',
        title,
        isLoading,
        disabled,
        variant = "contained",
        onClick,
        startIcon,
        endIcon,

        sx
    } = props;

    return (
        <Stack spacing={2} direction="row" className="w-full justify-center">
            <LoadingButton
                className={buttonClasses}
                color={color}
                type={type}
                disabled={disabled}
                fullWidth
                loading={isLoading}
                variant={variant}
                onClick={onClick}
                startIcon={startIcon}
                endIcon={endIcon}

                sx={sx}
            >
                {title}
            </LoadingButton>
        </Stack>
    );
};
